export default {
  path: '',
  component: () =>
    import('@/views/uspqrp/cost-management-services/Wrapper.vue'),
  children: [
    {
      path: '/uspqrp/services-costs-management',
      name: 'ServicesCostsManagementMain',
      component: () =>
        import('@/views/uspqrp/cost-management-services/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.servicesandcostmanagement'],
        },
      },
    },
  ],
};
